/* Version: 3.5.149 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import React from 'react';
import { typography } from './typography.js';

function wrapChildrenByType(children) {
  if (children === null || children === undefined) {
    return null;
  }
  return React.Children.map(children, function (child) {
    var _child$props;
    if (child === null || child === undefined) {
      return null;
    }
    if (child.type === 'i' && (_child$props = child.props) !== null && _child$props !== undefined && _child$props.children) {
      return /*#__PURE__*/React.cloneElement(_objectSpread(_objectSpread({}, child), {}, {
        type: 'span'
      }), _objectSpread(_objectSpread({}, child.props), {}, {
        style: {
          fontFamily: typography.fontFamilySerif,
          fontStyle: 'italic'
        }
      }));
    }
    return child;
  });
}

export { wrapChildrenByType };
